import { ButtonMainLogic as ButtonMain } from './ButtonMain.logic'

export default ButtonMain
